import { AuthedHome } from './-AuthedHome';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/shared/model';
import { parseDeepLinkFromQuery } from '@aegislab/shared';
import { handleHomeDeepLink } from '@/shared/lib/onboarding';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // Zustand persist hydrates synchronously from localStorage,
    // so getState() already has the rehydrated user by the time
    // TanStack Router's beforeLoad runs.
    const user = useAuthStore.getState().user;
    if (!user) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login' });
    }

    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      const query: Record<string, string> = {};
      for (const [k, v] of params.entries()) query[k] = v;
      const deepLink = parseDeepLinkFromQuery(query);
      if (deepLink) {
        // 온보딩 격리 중이면 열지 않고 보관 — 완료 직후 재생한다 (CP1 D4)
        handleHomeDeepLink(user, deepLink);
        window.history.replaceState({}, '', window.location.pathname);
      }
    }
  },
  component: AuthedHome,
});
